import { Routes } from '@angular/router';

export const PLACES_ENABLED = true;
export function loadPlacesSettings(): Promise<import('@angular/core').Type<any> | null> {
  return import('./components/places-settings/places-settings.component').then(module => module.PlacesSettingsComponent);
}
export const PLACES_ROUTES: Routes = [
  { path: 'places', loadComponent: () => import('./places/places-page.component').then(m => m.PlacesPageComponent) },
  { path: 'places/:slug', loadComponent: () => import('./places/places-page.component').then(m => m.PlacesPageComponent) },
];
